import { createSelector } from 'reselect';
export const getAdditionalQueryParams = state => state.additionalQueryParams;
export const getContinueSetup = createSelector([getAdditionalQueryParams], additionalQueryParams => additionalQueryParams.continueSetup);